import keycloak from '@vindr/services/keycloak';
import SelectFilter from '../templates/SelectFilter';
import { useGetAccounts } from '@vindr/services/actions/account.action';
import { useDebounce } from '@vindr/utils/hooks/useDebounce';
import { useMemo } from 'react';
import { useTranslation } from 'react-i18next';

interface Creator extends Omit<SelectFilter, 'title' | 'placeholder' | 'options'> {
  title?: string | boolean;
  placeholder?: string;
  value?: string | string[];
  onChange?: (value) => void;
  width?: number | string;
  params?: Parameters<typeof useGetAccounts>['0'];
}

const Creator = ({
  title,
  placeholder,
  value,
  onChange,
  width = 200,
  params,
  mode = 'multiple',
  ...props
}: Creator) => {
  const { t } = useTranslation('Vindoc');
  title = ['boolean', 'string'].includes(typeof title) ? title : t('Creator');
  placeholder = placeholder || t('Select Creator');
  const userInfo = keycloak.getUserInfo();

  const [searchTerm, handleSearch] = useDebounce<string>();
  const { data, isRefetching, isInitialLoading } = useGetAccounts({
    offset: 0,
    limit: 100,
    ...(!userInfo.is_super && { institutions: userInfo?.institutions }),
    ...params,
    fullname: searchTerm,
  });

  const accounts = data?.data;

  const options = useMemo(
    () =>
      accounts?.map((item) => ({
        value: item.id,
        label: `${item?.fullname || item.username || ''}`,
      })),
    [accounts]
  );

  return (
    <SelectFilter
      searchVietnamese
      loading={isInitialLoading || isRefetching}
      mode={mode}
      onClear={() => handleSearch(undefined)}
      onSearch={handleSearch}
      {...{ width, options, onChange, placeholder, title, value }}
      {...props}
    />
  );
};

export default Creator;
